import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text, Image, StyleSheet, View } from 'react-native'
import BuilderBottomModal from '../../../../ui/molecules/BuilderBottomModal'
import image from './HowToCreateProj.svg'
import { BtButton } from '@linqpal/components/src/ui'

const Footer: React.FC<{ setVisible: (arg: boolean) => void }> = ({
  setVisible,
}) => {
  const { t } = useTranslation('global')
  return (
    <View style={styles.footer}>
      <BtButton
        onPress={() => setVisible(false)}
        testID="MakePayment"
        style={{ borderRadius: 4 }}
      >
        {t('SelectProject.close-button-label')}
      </BtButton>
    </View>
  )
}

export const ProjectAlertForMobile: React.FC<{
  visible: boolean
  setVisible: (arg: boolean) => void
  title: string
}> = ({ visible, setVisible, title }) => {
  const { t } = useTranslation('global')
  return (
    <BuilderBottomModal
      visible={visible}
      height="90%"
      onClose={() => setVisible(false)}
      footer={<Footer setVisible={setVisible} />}
    >
      <View
        style={{ flexDirection: 'column', flex: 1, justifyContent: 'center' }}
      >
        <Image
          style={{
            width: 220,
            height: 172,
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: 30,
          }}
          source={{ uri: image }}
        />
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.subtitle}>
          {t('SelectProject.how-to-create-project-subtitle')}
        </Text>
      </View>
    </BuilderBottomModal>
  )
}

const styles = StyleSheet.create({
  title: {
    fontWeight: '700',
    fontSize: 20,
    lineHeight: 28,
    textAlign: 'center',
    marginBottom: 25,
    maxWidth: 320,
    alignSelf: 'center',
  },
  subtitle: {
    fontWeight: '400',
    fontSize: 16,
    lineHeight: 22,
    textAlign: 'center',
    color: '#394D5A',
    maxWidth: 315,
    alignSelf: 'center',
  },
  footer: {
    width: '100%',
    height: 80,
    justifyContent: 'center',
    borderTopWidth: 1,
    borderTopColor: '#E6EBEE',
    marginRight: -20,
  },
})
